// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { TYPE_KEYS, TYPE_CONFIG } from "./constants";

const AvailabilityTypeFilter = ({ activeTypes, onToggleType }) => {
  return (
    <div
      className="av-type-filter-group"
      role="group"
      aria-label="Nutzungsarten filtern (Mehrfachauswahl)"
    >
      <span className="av-type-filter-label">Nutzungsart</span>
      {TYPE_KEYS.map((type) => {
        const cfg = TYPE_CONFIG[type];
        const Icon = cfg.Icon;
        const isActive = activeTypes.has(type);
        return (
          <button
            key={type}
            type="button"
            className={`av-type-pill${isActive ? "" : " inactive"}`}
            style={
              isActive
                ? {
                    background: cfg.bg,
                    color: cfg.text,
                    borderColor: cfg.border,
                  }
                : undefined
            }
            onClick={() => onToggleType(type)}
            aria-pressed={isActive}
            aria-label={`${cfg.label} filtern`}
          >
            <Icon size={12} aria-hidden />
            {cfg.label}
          </button>
        );
      })}
    </div>
  );
};

export default AvailabilityTypeFilter;
